import { CardStats } from 'components/Cards/Cards';
import ProgressLoader from 'components/Loader/ProgressLoader';
import { apiUrls } from 'constants/apiUrls';
import { appRoutesUrls } from 'constants/appRoutesUrls';
import React, { useEffect, useState } from 'react'
import { Badge, Card, Col, Row } from 'react-bootstrap'
import { BiSolidChevronLeft } from 'react-icons/bi';
import { useNavigate, useParams } from 'react-router-dom';
import { customerService } from 'services/customerService';
import { bgInvoiceStatus, bgPaymentStatus } from 'utils/bgColor';
import { toDDMMYYYY } from 'utils/dateFormatter';

const CustomerDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [isLoader, setIsLoader] = useState(false);
    const [customerDetails, setCustomerDetails] = useState();

    useEffect(() => {
        if (id > 0) {
            setIsLoader(true);
            customerService.getCustomerDetails(apiUrls.getCustomerDetails(id)).then((res) => {
                setIsLoader(false);
                setCustomerDetails(res);
            }).catch((err) => setIsLoader(false));
        }
    }, [id]);

    return (
        <>
            <Row className="justify-content-center">
                <Col>
                    <Card className='card-default'>
                        <Card.Body>
                            {isLoader && <ProgressLoader />}
                            <Card.Title>
                                <span className="hand me-1">
                                    <BiSolidChevronLeft size={26} onClick={() => navigate(appRoutesUrls.customers())} /> Customer - <b>{customerDetails?.name}</b>
                                </span>
                            </Card.Title>
                            <Row className="row row-card-no-pd" style={{ padding: '0', marginBottom: '20px' }}>
                                <Col sm={6} md={5}>
                                    <Card className="card-stats">
                                        <Card.Body>
                                            <Row>
                                                <div className="numbers">
                                                    <p className="card-category"><b>Address</b></p>
                                                    <h5>{customerDetails?.address}</h5>
                                                </div>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col sm={6} md={2}>
                                    <Card className="card-stats">
                                        <Card.Body>
                                            <Row>
                                                <div className="numbers">
                                                    <p className="card-category"><b>Mobile</b></p>
                                                    <h5>{customerDetails?.mobileNo}</h5>
                                                </div>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col sm={6} md={3}>
                                    <Card className="card-stats">
                                        <Card.Body>
                                            <Row>
                                                <div className="numbers">
                                                    <p className="card-category"><b>Email</b></p>
                                                    <h5>{customerDetails?.email}</h5>
                                                </div>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col sm={6} md={2}>
                                    <Card className="card-stats">
                                        <Card.Body>
                                            <Row>
                                                <div className="numbers">
                                                    <p className="card-category"><b>GSTIN</b></p>
                                                    <h5>{customerDetails?.gstIn}</h5>
                                                </div>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <CardStats cardType="card-primary hand" goTo={() => navigate(appRoutesUrls.customerInvoices(customerDetails?.id))}>
                                        <h4 className="mb-0"><b>{customerDetails?.totalInvoices}</b></h4>
                                        <strong>Total Invoices</strong>
                                    </CardStats>
                                    <CardStats cardType="card-info hand" goTo={() => navigate(appRoutesUrls.customerInvoices(customerDetails?.id))}>
                                        <h4 className="mb-0"><b>{customerDetails?.buildingInvoices}</b></h4>
                                        <strong>InProgress</strong>
                                    </CardStats>
                                </Col>
                                <Col md={6}>
                                    <CardStats cardType="card-success hand" goTo={() => navigate(appRoutesUrls.customerInvoices(customerDetails?.id))}>
                                        <h4 className="mb-0"><b>{customerDetails?.completedInvoices}</b></h4>
                                        <strong>Completed</strong>
                                    </CardStats>
                                    <Row>
                                        <Col md={4}>
                                            <CardStats cardType="card-success hand" goTo={() => navigate(appRoutesUrls.customerInvoices(customerDetails?.id))}>
                                                <h4 className="mb-0"><b>{customerDetails?.paidInvoices}</b></h4>
                                                <strong>Paid</strong>
                                            </CardStats>
                                        </Col>
                                        <Col md={4}>
                                            <CardStats cardType="card-warning hand" goTo={() => navigate(appRoutesUrls.customerInvoices(customerDetails?.id))}>
                                                <h4 className="mb-0"><b>{customerDetails?.partlyPaidInvoices}</b></h4>
                                                <strong>Partly Paid</strong>
                                            </CardStats>
                                        </Col>
                                        <Col md={4}>
                                            <CardStats cardType="card-danger hand" goTo={() => navigate(appRoutesUrls.customerInvoices(customerDetails?.id))}>
                                                <h4 className="mb-0"><b>{customerDetails?.unpaidInvoices}</b></h4>
                                                <strong>Unpaid</strong>
                                            </CardStats>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div className={`card ${customerDetails?.lastInvoiceDetails && 'hand'}`}
                                        onClick={() => customerDetails?.lastInvoiceDetails
                                            && navigate(appRoutesUrls.invoicedetails(customerDetails?.lastInvoiceDetails?.invoiceId))}>
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between mt-2">
                                                <h4 className="text-muted mb-0">Last Invoice</h4>
                                                <h4 className="text-muted mb-0">
                                                    #{customerDetails?.lastInvoiceDetails?.invoiceId}
                                                </h4>
                                            </div>
                                            <div className="d-flex justify-content-between mt-1">
                                                <p className="text-muted mb-0">Invoice Date</p>
                                                <p className="text-muted mb-0">
                                                    {toDDMMYYYY(customerDetails?.lastInvoiceDetails?.invoiceDate) || 'N/A'}
                                                </p>
                                            </div>
                                            <div className="d-flex justify-content-between mt-1">
                                                <p className="text-muted mb-0">Invoice Status</p>
                                                <p className="text-muted mb-0">
                                                    {customerDetails?.lastInvoiceDetails ? (
                                                        <Badge bg={bgInvoiceStatus(customerDetails?.lastInvoiceDetails?.invoiceStatus)}>
                                                            {customerDetails?.lastInvoiceDetails?.invoiceStatus || 'N/A'}
                                                        </Badge>
                                                    ) : (<>N/A</>)}
                                                </p>
                                            </div>
                                            <div className="d-flex justify-content-between mt-1">
                                                <p className="text-muted mb-0">Payment Status</p>
                                                <p className="text-muted mb-0">
                                                    {customerDetails?.lastInvoiceDetails ? (
                                                        <Badge bg={bgPaymentStatus(customerDetails?.lastInvoiceDetails?.paymentStatus)}>
                                                            {customerDetails?.lastInvoiceDetails?.paymentStatus || 'N/A'}
                                                        </Badge>
                                                    ) : (<>N/A</>)}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default CustomerDetails;